module.exports = __webpack_public_path__ + "static/media/especialistas_testimonios5.20fca224.jpg";